import {
  Text,
  useRadioGroup,
  Stack,
  Image,
  Grid,
  GridItem
} from "@chakra-ui/react";
import RadioCard from "./RadioCard";

import blueCar from "../images/q8.png";
import redCar from "../images/q10.png";

function BinaryRadioGroup({ options, onChange }) {
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "",
    onChange
  });
  const group = getRootProps();
  return (
    <Grid {...group} templateColumns="repeat(2, 1fr)" gap={2}>
      {options.map((value, index) => {
        const radio = getRadioProps({ value });
        return (
          <GridItem key={value}>
            <RadioCard {...radio} width="50%">
              <Stack spacing={4}>
                <Image src={index ? redCar : blueCar} />
                <Text fontSize={12}>{value}</Text>
              </Stack>
            </RadioCard>
          </GridItem>
        );
      })}
    </Grid>
  );
}

export default BinaryRadioGroup;
